<template>
	<div class="register">
		<header>
			<div class="g-header">
				<!-- <div class="left">
          <div class="close-btn" @click="changeHome">
            <i class="icon-x"></i>
          </div>
        </div> -->
				<div class="middle fs-18">
					<div class="title">{{ $t("zhuce") }}</div>
				</div>
			</div>
		</header>
		<img src="@/assets/home/31.png" class="app-logo" alt="" />
		<div style="margin-top: 115px;margin-left: 60px;"><span style=" font-size: 21px;  color: #b8a78a;">Forex Gold
				USA</span></div>
		<div class="g-content flex-column">
			<div class="register-main">
				<van-cell-group class="login-body van-cell-group">
					<van-field :placeholder="$t('plusername')" v-model="username" clearable>
						<template #left-icon>
							<img src="@/assets/home/33.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<van-field clearable :placeholder="$t('plpassword')" type="password" v-model="password">
						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<van-field clearable :placeholder="$t('querenmma')" type="password" v-model="querenmma">
						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<van-field clearable :placeholder="$t('anquan')" type="password" v-model="anquan">
						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<van-field clearable :placeholder="$t('anquanmi')" type="password" v-model="anquanmi">
						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<van-field clearable :placeholder="$t('youxiang')" type="text" v-model="email">
						<template #left-icon>
							<img src="@/assets/home/35.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<div style=" margin-top: 5px;">
						<span style="  color: #e54d42; margin-left: -5px; margin-top: 10px;">*
							{{ $t("tianxx") }}！</span>
					</div>
					<div class="field-container">
						<van-field clearable :placeholder="$t('yanzhengma')" type="text" v-model="yanzhengma">
							<template #left-icon>
								<img src="@/assets/home/35.png" class="left-form-icon" alt="" />
							</template>

						</van-field>
						<div class="overlay-image">
							<Captcha ref="Captcha" />
						</div>
					</div>

					<!-- <div class="yanzheng">
						<img src="@/assets/home/33.png" class="left-form-icon" style="margin-left: -0.7rem;"
							alt="" />
						<input type="text" class="yanzheng-input" style="width:70%" :placeholder="$t('yanzhengma')">
					</div> -->
				</van-cell-group>
				<div class="register-bottom">
					<div>
						<div type="primary" round block class="Btnlogin" @click="ChangeRegister">
							{{ $t("wanchengzhuce") }}
						</div>
						<div class="has-acoount">
							<!-- 	<span>{{ $t("yiyouzhanghao") }}?</span> -->
							<span class="btn-tologin" @click="changeLogin">{{
                $t("qingdenglu")
              }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import loginApi from "@/api/login";
	import Captcha from "@/components/tabbar/Captcha.vue";
	import storeAction from "@/store/typed-actions";
	export default {
		name: "Register",
		components: {
			Captcha,
		},
		data() {
			return {
				username: "",
				password: "",
				inviter_id: "",
				querenmma: "",
				anquan: "",
				anquanmi: "",
				email: "",
				yanzhengma: "",
				captchaValue: "",
				yzm: "",
			};
		},
		methods: {

			changeLogin() {
				this.$router.push({
					path: "/login",
				});
			},
			changeHome() {
				this.$router.push({
					path: "/",
				});
			},
			ChangeRegister() {

				let cc = this.$refs.Captcha.getYam();
				const inputCode = this.yanzhengma.trim();

				// console.log('计算结果:', cc, '用户输入:', inputCode);

				if (!this.username) {
					this.$toast(this.$t('plusername'));
				} else if (!this.password) {
					this.$toast(this.$t('plpassword'));
				} else if (!this.querenmma) {
					this.$toast(this.$t('querenmma'));
				} else if (this.password !== this.querenmma) {
					this.$toast.fail(this.$t('liang'));
				} else if (!this.anquan || this.anquan.length < 6 || this.anquan.length > 20) {
					this.$toast(this.$t('aqqewad'));
				} else if (!this.anquanmi) {
					this.$toast(this.$t('anquanmi'));
				} else if (this.anquan !== this.anquanmi) {
					this.$toast.fail(this.$t('liangan'));
				} else if (!this.email) {
					this.$toast(this.$t('youxiang'));
				} else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
					this.$toast.fail(this.$t('youxiao'));
				} else if (!inputCode) {
					this.$toast.fail(this.$t('yanzhengma'));
					return false;
				} else if (inputCode !== String(cc)) {
					this.$toast.fail(this.$t('qsryz'));
					return false;
				} else {
					console.log(this.email, 22111)
					loginApi
						.register(this.username, this.password, "1", this.inviter_id, this.anquan, this.email)
						.then((data) => {
							// console.log(data.data, "注册成功");
							storeAction.loginDone(data.data);
						})
						.catch((err) => {
							this.$toast.clear();
							this.$toast.fail(err.msg);
						});
				}
			},
		},
		mounted() {
			// http://localhost:8080/register?inviter_id=37
			console.log(this.$route.query.inviter_id);
			this.inviter_id = this.$route.query.inviter_id;
		},
	};
</script>
<style lang="less" scoped>
	.field-container {
		position: relative;
		width: 100%;
	}

	.overlay-image {
		position: absolute;
		margin-left: 50%;
		top: 50%;
		transform: translateY(-50%);
		width: 35%;
		z-index: 1;
	}

	::v-deep .van-button--primary {
		color: #b8a78a;
	}

	::v-deep.input::placeholder {
		color: rgb(184, 167, 138);
	}

	.yanzheng {
		margin-left: -15px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 60%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 12px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;
		background-color: unset;
	}

	::v-deep .van-field__control {

		color: #b8a78a;
	}

	::v-deep .van-field__control::placeholder {
		color: rgb(184, 167, 138);
	}

	.app-logo {
		width: 1.3rem;
		height: 1.3rem;
		border-radius: 0.1rem;
		-o-object-fit: cover;
		object-fit: cover;
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translate(-220%, -1360%);
	}

	.register {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
		min-height: 100%;
	}

	.g-header {
		position: absolute;
		width: 100%;
		height: 1.18rem;
		text-align: center;
		z-index: 1;
		/* color: #fff; */
		/* background: #0e1530; */
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.left {
		z-index: 11;
		position: absolute;
		height: 100%;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.close-btn {
		padding: 0.3rem;
	}

	.icon-x {
		display: inline-block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		line-height: 0;
		font-size: 0;
		vertical-align: middle;
		transform: rotate(45deg);
	}

	.icon-x::after {
		content: "";
		display: block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		transform: rotate(-90deg);
	}

	.middle {
		z-index: 10;
		max-width: 80%;
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.fs-18 {
		font-size: 0.43rem;
	}

	.title {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.register-main {
		flex: 1;
		padding: 2rem 0.8rem 0.2rem;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		color: #a0a0a0;
		text-align: center;
	}

	.login-body {
		// margin-top: 1.7rem;
		padding: 0 0.68rem;
	}

	.van-cell-group {
		background: unset;
		position: unset;

		input {}
	}

	.van-cell {
		margin-left: -15px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 113%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 18px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;
		background-color: unset;
	}

	.van-field::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 0px solid #3d5179 !important;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.left-form-icon {
		width: 20px;
	}

	.c_a0a0a0 {
		color: #a0a0a0;
	}

	.register-bottom {
		margin-top: 0.6rem;
		flex: 1;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.Btnlogin {
		margin-left: 9px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 93%;
		padding: 10px 16px;
		overflow: hidden;
		margin-top: 12px;
		font-size: 14px;
		line-height: 24px;
		color: #b8a78a;
		border-radius: 30px;
		background-color: unset;
	}

	.has-acoount {
		margin-top: 0.2rem;
	}

	.btn-tologin {
		margin-left: 0.3rem;
		color: #b8a78a;
		font-size: 14px;
	}
</style>